const makeAPIUrl = (unitIds) =>
  `${
    window.PUBLIC_ENV.CONSOLIDATION_PREFIX
  }/api/missionaryPhoneNumbers?unitIds=${unitIds.join(",")}`;

const fetchphoneNumbers = (url) =>
  new Promise((resolve) => {
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        console.error(err);
        resolve({});
      });
  });

const findParentId = (unitIds, unitId) =>
  unitIds.find((i) => i.unit === unitId)?.parent;

// fetchphoneNumbers never rejects (a failed request resolves {}), so this
// always resolves: with the units' numbers, falling back to their stake's
export default async function getMissionaryPhoneNumbers(unitIds) {
  if (!unitIds.length) return {};

  const unitIdsOnly = unitIds.map(({ unit }) => unit);
  const response = await fetchphoneNumbers(makeAPIUrl(unitIdsOnly));
  try {
    // if there's no phone numbers, check at the stake / mission level
    const unitsWithParentIds = Object.entries(response)
      .filter(([, phoneNumbers]) => phoneNumbers?.length === 0)
      .map(([unitId]) => ({ unitId, punit: findParentId(unitIds, unitId) }));
    // a unit without a parent can't fall back, and each stake is asked for
    // once
    const parentIds = [
      ...new Set(unitsWithParentIds.map(({ punit }) => punit).filter(Boolean))
    ];
    if (!parentIds.length) return response;

    const parentResponse = await fetchphoneNumbers(makeAPIUrl(parentIds));
    // every unit sharing a stake gets that stake's numbers
    unitsWithParentIds.forEach(({ unitId, punit }) => {
      if (Array.isArray(parentResponse?.[punit]))
        response[unitId] = parentResponse[punit];
    });
  } catch {
    // keep the units' own results
  }
  return response;
}
